import {
  Directive,
  ElementRef,
  OnInit,
  OnDestroy,
  PLATFORM_ID,
  Inject,
  Input,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Directive({
  selector: '[appAnimateOnScroll]',
  standalone: true,
})
export class AnimateOnScrollDirective implements OnInit, OnDestroy {
  @Input() animationClass: string = 'animate-in';
  @Input() threshold: number = 0.1;
  @Input() rootMargin: string = '0px 0px -100px 0px';

  private observer: IntersectionObserver | null = null;

  constructor(
    private elementRef: ElementRef,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.setupObserver();
    }
  }

  private setupObserver(): void {
    if (typeof IntersectionObserver !== 'undefined') {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add(this.animationClass);
              // Para de observar após animar
              this.observer?.unobserve(entry.target);
            }
          });
        },
        {
          threshold: this.threshold,
          rootMargin: this.rootMargin,
        }
      );

      this.observer.observe(this.elementRef.nativeElement);
    } else {
      // Fallback para browsers antigos - adiciona classe imediatamente
      this.elementRef.nativeElement.classList.add(this.animationClass);
    }
  }

  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}
